<template>
<div class="mt-16">
                <h2 class="sr-only"></h2>

                <div class="space-y-2 px-4 sm:flex sm:items-baseline sm:justify-between sm:space-y-0 sm:px-0">
                    <div class="flex sm:items-baseline sm:space-x-4">
                        <h1 class="text-2xl font-medium text-primaryText tracking-tight sm:text-2xl pb-4">诊所地图 </h1>
                    </div>
                </div>  
                
                <div class="bg-gray-100   sm:rounded-lg">
                    <iframe data-v-07439425="" width="100%" height="450" frameborder="0" :src="googlemap_url" allowfullscreen="allowfullscreen" style="border: 0px;"></iframe>
                </div>
            </div>

</template>


<script setup>

const props = defineProps({
    googlemap_url: {
        type: String,
        required: true
    }
})

</script>